export const agents = [
  {
    id: "customer-support",
    slug: "customer-support",
    name: "Customer Support",
    industry: "Atendimento",
    shortDescription: "Automatize atendimento 24/7 com resolucao automatica de tickets",
    price: 99,
    channels: ["WhatsApp", "Telegram", "Email", "Discord", "Slack"],
    features: ["Auto-resolve tickets", "Smart escalation", "Multi-channel", "24/7"],
  },
  {
    id: "e-commerce",
    slug: "e-commerce",
    name: "E-Commerce",
    industry: "Vendas",
    shortDescription: "Automatize sua loja online: pedidos, suporte e carrinho abandonado",
    price: 149,
    channels: ["WhatsApp", "Instagram", "Email"],
    features: ["Order management", "Cart recovery", "Inventory sync", "Support"],
  },
  {
    id: "real-estate",
    slug: "real-estate",
    name: "Real Estate",
    industry: "Imobiliario",
    shortDescription: "Qualificacao de leads e agendamento de visitas automatico",
    price: 197,
    channels: ["WhatsApp", "Instagram", "Facebook"],
    features: ["Lead qualification", "Visit scheduling", "Listing distribution", "Follow-up"],
  },
  {
    id: "consultancy",
    slug: "consultancy",
    name: "Consultancy",
    industry: "Consultoria",
    shortDescription: "Triagem de leads e agendamento de reunioes para consultores",
    price: 149,
    channels: ["Email", "Telegram", "WhatsApp", "Calendly"],
    features: ["Lead triage", "Meeting scheduling", "Research", "Proposal follow-up"],
  },
  {
    id: "marketing-agencies",
    slug: "marketing-agencies",
    name: "Marketing Agencies",
    industry: "Marketing",
    shortDescription: "Gestao de redes sociais, DMs e monitoramento de mencoes",
    price: 249,
    channels: ["Instagram", "X/Twitter", "Facebook", "LinkedIn"],
    features: ["Content scheduling", "DM management", "Mention monitoring", "Reports"],
  },
];
